// extracted by mini-css-extract-plugin
export default {"message":"message---v1PyV","message__content":"message__content---CioyK","error":"error---e39Q_","stack":"stack---FQSwS"};